import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TableSortLabel,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from 'react-router-dom';

const LessonsTable = ({ lessons, onDeleteLesson }) => {
  const navigate = useNavigate();
  const [orderBy, setOrderBy] = useState('order');
  const [order, setOrder] = useState('asc');

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedLessons = [...lessons].sort((a, b) => {
    let aValue = a[orderBy];
    let bValue = b[orderBy];

    // Handle numeric values for order
    if (orderBy === 'order') {
      aValue = parseInt(aValue);
      bValue = parseInt(bValue);
    }

    // Handle string comparison
    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }

    if (order === 'asc') {
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    } else {
      return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    }
  });

  const createSortHandler = (property) => () => {
    handleSort(property);
  };

  return (
    <TableContainer component={Paper} sx={{ marginTop: 2, boxShadow: 3 }}>
      <Table>
        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>
              <TableSortLabel
                active={orderBy === 'title'}
                direction={orderBy === 'title' ? order : 'asc'}
                onClick={createSortHandler('title')}
              >
                Título
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              <TableSortLabel
                active={orderBy === 'description'}
                direction={orderBy === 'description' ? order : 'asc'}
                onClick={createSortHandler('description')}
              >
                Descripción
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              <TableSortLabel
                active={orderBy === 'order'}
                direction={orderBy === 'order' ? order : 'asc'}
                onClick={createSortHandler('order')}
              >
                Orden
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Duración</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Creado</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedLessons.map((lesson, index) => (
            <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } }}>
              <TableCell>{lesson.title}</TableCell>
              <TableCell>{lesson.description}</TableCell>
              <TableCell>{lesson.order}</TableCell>
              <TableCell>{lesson.duration} min</TableCell>
              <TableCell>{new Date(lesson.createdAt).toLocaleDateString()}</TableCell>
              <TableCell>
                <IconButton
                  color="secondary"
                  onClick={() => onDeleteLesson(lesson.id)}
                >
                  <DeleteIcon />
                </IconButton>
                <IconButton
                  color="primary"
                  onClick={() => navigate(`/settings/lesson/${lesson.id}`)}
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LessonsTable;